module.exports = __webpack_public_path__ + "img/3.2e6c8acc.jpg";